import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFaq = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Faq_svg__a)">
      <mask
        id="Faq_svg__b"
        width={28}
        height={28}
        x={6}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M20 6a14 14 0 1 0 0 28 14 14 0 0 0 0-28m-.35 22.9a2.612 2.612 0 0 1-2.557-3.641 2.61 2.61 0 0 1 2.557-1.569 2.612 2.612 0 0 1 2.557 3.641A2.61 2.61 0 0 1 19.65 28.9m2.1-7.9-.34 1.46h-3.54l-.47-3.48c2.25 0 3.74-.51 3.74-1.89a1.44 1.44 0 0 0-1.54-1.46 1.66 1.66 0 0 0-1.43.9l-3.88-1.75a5.51 5.51 0 0 1 5.5-3.64c3.8 0 5.92 2.31 5.92 5.23A4.65 4.65 0 0 1 21.75 21"
        />
      </mask>
      <g mask="url(#Faq_svg__b)">
        <path
          fill="#F7A941"
          d="M10.15 23.46-2.1 16.39 4.97 4.14z"
        />
        <path
          fill="#F7A941"
          d="m-9.17 28.64 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m29.47 18.28-12.25-7.07 7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m4.97 4.14 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m10.15 23.46 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m24.29-1.03-7.07 12.24L4.97 4.14z"
        />
        <path
          fill="#F18700"
          d="m10.15 23.46 12.25 7.07-7.07 12.25zM34.65 37.6 22.4 30.53l7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="M29.47 18.28 22.4 30.53l-12.25-7.07z"
        />
        <path
          fill="#F7A941"
          d="m15.33 42.78 7.07-12.25 12.25 7.07zM15.33 42.78 3.08 35.71l7.07-12.25zM10.15 23.46 3.08 35.71l-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="m24.29-1.03 12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m29.47 18.28 7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="M43.61-6.21 36.54 6.04 24.29-1.03z"
        />
        <path
          fill="#F7A941"
          d="m29.47 18.28 12.25 7.08-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m48.79 13.11-7.07 12.25-12.25-7.08z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Faq_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFaq);

export default ForwardRef;
